<template>
  <res-dialog :showDialog="showDialog"
              :title="capitalizeFirstLetter(title)"
              :titleClass="'resBlue darken-1 white--text'"
              :iconColor="'white'"
              :maxWidth="maxWidth"
              :setWidth="width"
              saveButtonText="OK"
              :saveDisabled="isSaveDisabled"
              saveButtonWidth="129"
              cancelButtonText="CANCEL"
              cancelButtonWidth="113"
              @cancel="cancel"
              @save="save">
    <v-card-text>     
          <label>Notes</label>
          <v-text-field v-model="noteText"
                        class="mt-0 pt-0"
                        hide-details
                        outlined
                        dense
                        height="30"></v-text-field>       
      </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';

  export default {
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      title: {
        type: String
      }
    },
    mixins: [IsNullOrWhitespaceMixin],
    data() {
      return {
        noteText: ''
      }
    },
    components: {
      ResDialog
    },
    methods: {
      capitalizeFirstLetter: (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      save() {
        this.$emit('save', this.noteText)
      },
      cancel() {
        this.$emit('cancel', true)
      }
    },
    computed: {
      isSaveDisabled() {
        // make sure we have selected everything
        if (this.isNullOrWhitespace(this.noteText)) {
          return true;
        }
        return false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .base-dialog {
    .res-col-10

  {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  }

  .theme--light.v-btn-toggle::v-deep {
    .v-btn.v-btn

  {
    border: solid 1px var(--v-resGrey-darken1) !important;
  }
  }
</style>
